export default __webpack_public_path__ + "static/media/gmail.b70a7a86.png";